module.exports = __webpack_public_path__ + "linea-arrows-10.5873a30e6baace5f9246.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-arrows-10.svg
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-arrows-10.svg
// module chunks = styles